import React, { useState, useEffect, useContext } from 'react'
import slaRepository from '../SlaRepository'
import { Grid, Paper, Typography } from '@material-ui/core'
import { secondsToStringTimer } from '../../../utils/Formatter'
import { makeStyles } from '@material-ui/core/styles'
import useQueryFilter from '../useQueryFilter'
import { AuthContext } from 'elentari'

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(2)
  },
  centerText: {
    display: 'flex',
    justifyContent: 'center'
  }
}))

function useFetchTempos(props) {
  const { query, geral } = props
  const [temposFila, setTemposFila] = useState({})
  const [temposAnalise, setTemposAnalise] = useState({})

  useEffect(() => {
    async function fetchData(query) {
      if (query.dataInicio && query.dataFim) {
        const [responseFila, responseAnalise] = await Promise.all([
          slaRepository.temposFila(
            query.dataInicio,
            query.dataFim,
            geral,
            query.empresaId
          ),
          slaRepository.temposAnalise(
            query.dataInicio,
            query.dataFim,
            geral,
            query.empresaId
          )
        ])
        if (responseFila.ok)
          setTemposFila({
            medio: secondsToStringTimer(responseFila.data.tempomedio),
            maximo: secondsToStringTimer(responseFila.data.tempomaximo)
          })
        if (responseAnalise.ok)
          setTemposAnalise({
            medio: secondsToStringTimer(responseAnalise.data.tempomedio),
            maximo: secondsToStringTimer(responseAnalise.data.tempomaximo)
          })
      }
    }
    fetchData(query)
  }, [query, geral])

  return [temposFila, temposAnalise]
}

export default function CardsTempo(props) {
  const classes = useStyles()
  const [query, periodo] = useQueryFilter(props.location.search)
  const [temposFila, temposAnalise] = useFetchTempos({ query })
  const [temposFilaGeral, temposAnaliseGeral] = useFetchTempos({
    query,
    geral: true
  })
  const { user } = useContext(AuthContext)
  const isGestor = user.realm === 'gestor'

  return (
    <>
      <Grid item xs={12} sm={6} lg={3}>
        <Paper className={classes.card}>
          <Typography gutterBottom>Tempo médio na fila</Typography>
          <Typography variant="caption">{periodo}</Typography>
          <Typography variant="h5">{temposFila.medio}</Typography>
          {isGestor && (
            <Typography variant="subtitle2" color="textSecondary">
              {temposFilaGeral.medio} para todos os centros de custo
            </Typography>
          )}
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <Paper className={classes.card}>
          <Typography gutterBottom>Tempo máximo na fila</Typography>
          <Typography variant="caption">{periodo}</Typography>
          <Typography variant="h5">{temposFila.maximo}</Typography>
          {isGestor && (
            <Typography variant="subtitle2" color="textSecondary">
              {temposFilaGeral.maximo} para todos os centros de custo
            </Typography>
          )}
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <Paper className={classes.card}>
          <Typography gutterBottom>Tempo médio na análise</Typography>
          <Typography variant="caption">{periodo}</Typography>
          <Typography variant="h5">{temposAnalise.medio}</Typography>
          {isGestor && (
            <Typography variant="subtitle2" color="textSecondary">
              {temposAnaliseGeral.medio} para todos os centros de custo
            </Typography>
          )}
        </Paper>
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <Paper className={classes.card}>
          <Typography gutterBottom>Tempo máximo na análise</Typography>
          <Typography variant="caption">{periodo}</Typography>
          <Typography variant="h5">{temposAnalise.maximo}</Typography>
          {isGestor && (
            <Typography variant="subtitle2" color="textSecondary">
              {temposAnaliseGeral.maximo} para todos os centros de custo
            </Typography>
          )}
        </Paper>
      </Grid>
    </>
  )
}
